// Polyfills
import 'regenerator-runtime/runtime.js'; //支持ES6的async之类的语法
import 'es6-object-assign/auto';
import 'core-js/fn/array/includes';
import 'core-js/fn/promise/finally';
import 'intl'; // For Safari 9

import React from 'react';
import ReactDOM from 'react-dom';

import analytics from '../lib/analytics';
import AppStateHOC from '../lib/app-state-hoc.jsx';
import BrowserModalComponent from '../components/browser-modal/browser-modal.jsx';
import supportedBrowser from '../lib/supported-browser';

import styles from '../playground/index.css';

import NavRouter from './nav-router.jsx';
import ReactModal from "react-modal";

// Register "base" page view
analytics.pageview('/');

const appTarget = document.createElement('div');
appTarget.className = styles.app;
document.body.appendChild(appTarget);
window.appTarget = appTarget;
ReactModal.setAppElement(appTarget);

const ua = navigator.userAgent.toLocaleLowerCase();
let browserV = null;
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(ua)) {
    browserV = 'chrome';
    window.onload=function(){
		setTimeout(function() {
			window.scrollTo(0, 1)
		}, 0);
	};
} else {
    browserV = '手机'
    if (ua.match(/msie/i) != null || ua.match(/trident/i) != null) {
        browserV = "IE";
    } else if (ua.match(/firefox/i) != null) {
        browserV = "火狐";
    } else if (ua.match(/ubrowser/i) != null) {
        browserV = "UC";
    } else if (ua.match(/opera/i) != null) {
        browserV = "欧朋";
    } else if (ua.match(/bidubrowser/i) != null) {
        browserV = "百度";
    } else if (ua.match(/metasr/i) != null) {
        browserV = "搜狗";
    } else if (ua.match(/tencenttraveler/i) != null || ua.match(/qqbrowse/i) != null) {
        browserV = "QQ";
    } else if (ua.match(/maxthon/i) != null) {
        browserV = "遨游";
    } else if (ua.match(/chrome/i) != null) {

        if (ua.match(/edg/) != null) {
            browserV = "edg";
        } else {
            browserV = "chrome";
        }
        for (var key in navigator.plugins) {
            // np-mswmp.dll文件在chromium及chrome未查询到
            if (navigator.plugins[key].filename == 'np-mswmp.dll') {
                browserV = '360'
            }
        }

    } else if (ua.match(/AppleWebKit/i) != null || ua.match(/safari/i) != null) {
        browserV = "safari";
    }
}

if (browserV !== 'chrome' && browserV !== 'safari' && browserV !== "火狐") {
    window.browser();
}


if (supportedBrowser()) {
    // require needed here to avoid importing unsupported browser-crashing code
    // at the top level
    ReactDOM.render(<NavRouter />, appTarget);

} else {
    BrowserModalComponent.setAppElement(appTarget);
    const WrappedBrowserModalComponent = AppStateHOC(BrowserModalComponent, true /* localesOnly */);
    const handleBack = () => { };
    // eslint-disable-next-line react/jsx-no-bind
    ReactDOM.render(<WrappedBrowserModalComponent onBack={handleBack} />, appTarget);
}
